// TODO: Eventually move to vue-i18n to use template strings
export default {
  skipSave: 'No changes. Skipping save!',
  successfullySave: 'Successfully saved!',
  successfullyDeployed: (name: string) => `${name} successfully deployed!`,
  successfullyAddRule: 'Rule successfully added to policy!',
  successfullyDuplicated: (id: string, name: string) => `${id} duplicated to ${name}!`,
  successfullyDuplicatedTo: (id: string, to: string) => `${id} duplicated into ${to}!`,
  successfullyMerged: (id: string) => `${id} successfully merged!`,
  successfullyCreateDraft: `New draft successfully created!`,
  successfullyDeleteDraft: `Your draft has been discarded! You will be directed to the release version.`,
  successfullyDeleteRule: `The rule has been successfully deleted! You will be directed to homepage.`,
  successfullyDeletePolicy: `The policy has been successfully deleted! You will be directed to homepage.`,
  successfullyDeleteUserFunction: `The function has been successfully deleted! You will be directed to homepage.`,
  extensionsSavedLocally: 'Extensions updated. Click "Save my draft" to persist your changes.',
  autosaved: 'Autosaved',
  createDraftFromOutdated:
    'FYI: Some rules in the release branch of this policy were outdated. We have automatically pulled their latest version for you!',
}
